import { NAV_ITEMS } from "@/components/sections/header/nav-config";
import LangSwitcher from "@/components/sections/header/LangSwitcher";

export default function MobileMenu({ t, lang, setLang, scrollTo }) {
  return (
    <div
      className="lg:hidden border-t border-[var(--border)] bg-white px-6 py-4 space-y-3"
      data-testid="mobile-menu"
    >
      {NAV_ITEMS.map((item) => (
        <button
          key={item.id}
          onClick={() => scrollTo(item.id)}
          className="block w-full text-left py-3 min-h-[44px] font-semibold text-[var(--heading)]"
          data-testid={`mobile-nav-${item.id}`}
        >
          {t.nav[item.key]}
        </button>
      ))}
      <LangSwitcher lang={lang} setLang={setLang} variant="mobile" />
    </div>
  );
}
